import React from 'react';
import { onboardingStyles } from '../../../components/UI/OnboardingModal.styles';

export const MAP_LIST_ONBOARDING_KEY = 'mapListOnboarding';

export const mapListOnboarding = {
  title: 'Find Your Perfect Home',
  badge: 'Map Tool',
  image: 'https://s3.us-west-2.amazonaws.com/adu.homewip/tutorial/onboarding-map-1.webp',
  content: (
    <>
      <p className={onboardingStyles.paragraph}>
        <span className={onboardingStyles.highlight}>Enter your address.</span>
      </p>

      <p className={onboardingStyles.paragraph}>
        Use filters to select a plan by square footage and the number of bedrooms and bathrooms.
      </p>

      <p className={onboardingStyles.paragraph}>
        Scroll to see different floor plans - use width and length for reference.
      </p>

      <p className={onboardingStyles.paragraph}>
        <span className={onboardingStyles.highlight}>Select the floor plan</span> to try in your
        backyard.
      </p>

      <p className={onboardingStyles.paragraph}>Drag and turn the ADU to the desired location.</p>

      <p className={onboardingStyles.paragraph}>
        <span className={onboardingStyles.highlight}>Click the estimate</span> to learn more.
      </p>
    </>
  ),
  buttonText: 'Get started',
};

export const planViewOnboarding = {
  title: 'Your Perfect Home',
  badge: 'Plan View',
  image: 'https://s3.us-west-2.amazonaws.com/adu.homewip/tutorial/onboarding-plan-view-1.webp',
  content: (
    <>
      <p className={onboardingStyles.paragraph}>
        The <span className={onboardingStyles.highlight}>estimate</span> is a range to account for
        various site-specific conditions and contractor pricing models.
      </p>

      <p className={onboardingStyles.paragraph}>
        Scroll down to see the <span className={onboardingStyles.highlight}>floor plan in 2D</span>.
      </p>

      <p className={onboardingStyles.paragraph}>
        The <span className={onboardingStyles.highlight}>gallery</span> shows floor plans and
        possible exterior options.
      </p>

      <p className={onboardingStyles.paragraph}>
        Estimate details provide more information on what goes into the estimate, item by item. Some
        include links to shops to confirm current pricing.
      </p>

      <p className={onboardingStyles.paragraph}>
        <span className={onboardingStyles.highlight}>&quot;Configure&quot;</span> takes you to a
        complete 3D model, where you can check all elevations, change kitchen cabinet styles, and
        add utility upgrades.
      </p>

      <p className={onboardingStyles.paragraph}>
        If the plan works, reach out to buy and get permits. When in doubt,{' '}
        <span className={onboardingStyles.highlight}>book a call</span> with an ADU expert.
      </p>
    </>
  ),
  buttonText: 'Get started',
};
